import React, { useState } from "react";
import "./Managercompany.css";
import Managerassets from './Managerassets';
 import AssetsManagerNew from './AssetsManagerNew';
import Allocation from './Allocation';


/* ---------- Dummy Section Component ---------- */
const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

/* ---------- Main Company Component ---------- */
const Asets = () => {
  const tabs = [
    { id: 9, name: "DASHBORD", component: () => <Managerassets title="Personal Details" /> },
    { id: 10, name: "ASSETS", component: () => <AssetsManagerNew title="Personal Details" /> },
  { id: 11, name: "ALLOCATION", component: () => <Allocation title="Family Details" /> },
 
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="company-container">
      {/* <h2 className="company-title">HR Management System</h2> */}
<style>{`
  /* Default (Mobile first) – kuch change nahi */
  .company-scroll-container {
    position: static;
    background: #fff;
  }

  .company-buttons-row {
    display: flex;
    // gap: 10px;
    flex-wrap: wrap;
  }

  .company-button {
    padding: 8px 16px;
    border: none;
    background: #f0f0f0;
    cursor: pointer;
    border-radius: 6px;
    white-space: nowrap;
  }

  .company-button.active {
    background: #7564e6;
    color: #fff;
  }

  /* ✅ Desktop / Laptop only */
  @media (min-width: 769px) {
    .company-scroll-container {
      position: sticky;
      top: 0;
      z-index: 100;
      padding: 10px 0;
    }
  }
`}</style>
      {/* Tabs */}
      <div className="company-scroll-container">
        <div className="company-buttons-row">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`company-button ${activeTab === tab.id ? "active" : "PERSONAL"}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default Asets;
